import { defineMessages } from 'react-intl';

/** The cast step of the directed video (design directed-video b1 to b4, j1). */
export const castMessages = defineMessages({
  title: { id: 'app.sml.musicVideo.directed.cast.title', defaultMessage: 'Who and what is in your video?' },
  intro: {
    id: 'app.sml.musicVideo.directed.cast.intro',
    defaultMessage:
      'Add photos of the people, places and things that come back from shot to shot. The director keeps them the same in every shot. You can also skip this: a video with no recurring person works too.',
  },
  introPhone: {
    id: 'app.sml.musicVideo.directed.cast.introPhone',
    defaultMessage: 'Photos of people, places and things that come back in every shot. Or skip it.',
  },

  // The roles
  rolesLabel: { id: 'app.sml.musicVideo.directed.cast.rolesLabel', defaultMessage: 'The role of {label}' },
  rolePerson: { id: 'app.sml.musicVideo.directed.cast.role.person', defaultMessage: 'Person' },
  rolePlace: { id: 'app.sml.musicVideo.directed.cast.role.place', defaultMessage: 'Place' },
  roleObject: { id: 'app.sml.musicVideo.directed.cast.role.object', defaultMessage: 'Object' },
  roleStyle: { id: 'app.sml.musicVideo.directed.cast.role.style', defaultMessage: 'Style' },

  // One card
  labelPlaceholder: {
    id: 'app.sml.musicVideo.directed.cast.labelPlaceholder',
    defaultMessage: 'Name it: me, the red car',
  },
  labelAria: { id: 'app.sml.musicVideo.directed.cast.labelAria', defaultMessage: 'The name of this picture' },
  unnamed: { id: 'app.sml.musicVideo.directed.cast.unnamed', defaultMessage: 'this picture' },
  defaultName: { id: 'app.sml.musicVideo.directed.cast.defaultName', defaultMessage: 'Character {number}' },
  remove: { id: 'app.sml.musicVideo.directed.cast.remove', defaultMessage: 'Remove {label} from the cast' },
  madeByAi: { id: 'app.sml.musicVideo.directed.cast.madeByAi', defaultMessage: 'Made by AI' },
  noPicture: { id: 'app.sml.musicVideo.directed.cast.noPicture', defaultMessage: 'Your photo' },
  uploading: { id: 'app.sml.musicVideo.directed.cast.uploading', defaultMessage: 'Uploading' },
  makingPicture: {
    id: 'app.sml.musicVideo.directed.cast.makingPicture',
    defaultMessage: 'Making the picture · about 20 s',
  },
  pictureFailed: {
    id: 'app.sml.musicVideo.directed.cast.pictureFailed',
    defaultMessage: 'The AI could not make this picture. Try other words.',
  },
  // A failed picture by its reason, and its actions (owner report 2026-10-20)
  pictureFailedRefused: {
    id: 'app.sml.musicVideo.directed.cast.pictureFailed.refused',
    defaultMessage: 'The image model refused these words. Change the words and try again.',
  },
  pictureFailedError: {
    id: 'app.sml.musicVideo.directed.cast.pictureFailed.error',
    defaultMessage: 'A technical problem stopped this picture. Try again. It did not use up an AI picture.',
  },
  pictureFailedQuota: {
    id: 'app.sml.musicVideo.directed.cast.pictureFailed.quota',
    defaultMessage: 'The AI is busy right now. Try again later. It did not use up an AI picture.',
  },
  tryAgain: { id: 'app.sml.musicVideo.directed.cast.tryAgain', defaultMessage: 'Try again' },
  changeWords: { id: 'app.sml.musicVideo.directed.cast.changeWords', defaultMessage: 'Change the words' },

  // The add card
  addTitle: { id: 'app.sml.musicVideo.directed.cast.addTitle', defaultMessage: 'Add to the cast' },
  addText: {
    id: 'app.sml.musicVideo.directed.cast.addText',
    defaultMessage: 'Drop photos here. JPG or PNG, one person or thing per photo.',
  },
  upload: { id: 'app.sml.musicVideo.directed.cast.upload', defaultMessage: 'Upload photos' },
  uploadPhone: { id: 'app.sml.musicVideo.directed.cast.uploadPhone', defaultMessage: 'Add photos' },
  uploadNeedsConsent: {
    id: 'app.sml.musicVideo.directed.cast.uploadNeedsConsent',
    defaultMessage: 'Tick the box below first. Every photo that you upload needs it.',
  },
  makePicture: { id: 'app.sml.musicVideo.directed.cast.makePicture', defaultMessage: 'Make a picture' },
  // The artist picture (owner request 2026-10-19)
  useArtistPicture: {
    id: 'app.sml.musicVideo.directed.cast.useArtistPicture',
    defaultMessage: 'Use my artist picture',
  },
  useArtistPictureHint: {
    id: 'app.sml.musicVideo.directed.cast.useArtistPictureHint',
    defaultMessage: 'Adds your artist picture as you. It needs no tick.',
  },
  errorArtistPicture: {
    id: 'app.sml.musicVideo.directed.cast.error.artistPicture',
    defaultMessage: 'We could not add your artist picture. Try again, or upload a photo.',
  },
  noPicturesLeft: {
    id: 'app.sml.musicVideo.directed.cast.noPicturesLeft',
    defaultMessage: 'No AI pictures left for this video',
  },
  fullTitle: { id: 'app.sml.musicVideo.directed.cast.fullTitle', defaultMessage: 'The cast is full' },
  fullText: {
    id: 'app.sml.musicVideo.directed.cast.fullText',
    defaultMessage: '{max} of {max}. Remove one to add another.',
  },
  emptyTitle: { id: 'app.sml.musicVideo.directed.cast.emptyTitle', defaultMessage: 'No cast yet' },
  emptyText: {
    id: 'app.sml.musicVideo.directed.cast.emptyText',
    defaultMessage: 'Drop photos of you, your band, a place or a thing. Or make a picture. Or go on with no cast.',
  },
  count: {
    id: 'app.sml.musicVideo.directed.cast.count',
    defaultMessage: '{count} of {max} in the cast · {left} of {total} AI pictures left',
  },

  // The consent (fixed copy of the design)
  consent: {
    id: 'app.sml.musicVideo.directed.cast.consent',
    defaultMessage: 'I have the right to use these photos, and everyone in them agreed.',
  },
  consentDetail: {
    id: 'app.sml.musicVideo.directed.cast.consentDetail',
    defaultMessage: 'Only adults. Photos of children are not allowed. We store who ticked this box and when.',
  },
  consentScope: {
    id: 'app.sml.musicVideo.directed.cast.consentScope',
    defaultMessage:
      'Only for photos that you upload. Pictures that MUSIC24 makes and your artist picture need no tick.',
  },
  consentError: {
    id: 'app.sml.musicVideo.directed.cast.consentError',
    defaultMessage: 'Tick the box to go on. Your cast has photos that you uploaded.',
  },

  // The foot
  noCast: { id: 'app.sml.musicVideo.directed.cast.noCast', defaultMessage: 'Make it with no cast' },
  free: { id: 'app.sml.musicVideo.directed.cast.free', defaultMessage: 'Free until you confirm the price' },
  writeStories: {
    id: 'app.sml.musicVideo.directed.cast.writeStories',
    defaultMessage: 'Write {count} stories',
  },
  // One label for every forward button of the cast step once a story is picked (owner fix 2026-10-19).
  goOn: {
    id: 'app.sml.musicVideo.directed.cast.goOn',
    defaultMessage:
      'Go on to the {step, select, style {style} script {script} price {price} progress {video} other {next step}}',
  },
  castNotReady: {
    id: 'app.sml.musicVideo.directed.cast.notReady',
    defaultMessage: 'Wait until every character is ready.',
  },

  // Errors
  errorType: { id: 'app.sml.musicVideo.directed.cast.error.type', defaultMessage: 'Use a JPG, PNG or WebP photo.' },
  errorSize: {
    id: 'app.sml.musicVideo.directed.cast.error.size',
    defaultMessage: 'This photo is too big. Use a photo of up to 25 MB.',
  },
  errorUpload: {
    id: 'app.sml.musicVideo.directed.cast.error.upload',
    defaultMessage: 'The photo did not upload. Try again.',
  },
  errorConsent: {
    id: 'app.sml.musicVideo.directed.cast.error.consent',
    defaultMessage: 'Tick the box first. Every photo that you upload needs it.',
  },
  errorPictures: {
    id: 'app.sml.musicVideo.directed.cast.error.pictures',
    defaultMessage: 'No AI pictures left for this video.',
  },
  errorCastFull: {
    id: 'app.sml.musicVideo.directed.cast.error.castFull',
    defaultMessage: 'The cast is full. Remove one to add another.',
  },
  errorBusy: {
    id: 'app.sml.musicVideo.directed.cast.error.busy',
    defaultMessage: 'The director is working. Try again when it is done.',
  },
  errorVideoLimit: {
    id: 'app.sml.musicVideo.directed.cast.error.videoLimit',
    defaultMessage: 'This video has no director runs left.',
  },
  errorDayLimit: {
    id: 'app.sml.musicVideo.directed.cast.error.dayLimit',
    defaultMessage: 'You used every director run of today. Try again tomorrow.',
  },
  errorStale: {
    id: 'app.sml.musicVideo.directed.cast.error.stale',
    defaultMessage: 'The video changed on another screen. We loaded it again.',
  },
  errorDemo: {
    id: 'app.sml.musicVideo.directed.cast.error.demo',
    defaultMessage: 'The example artist is read only.',
  },
  errorFailed: {
    id: 'app.sml.musicVideo.directed.cast.error.failed',
    defaultMessage: 'That did not work. Try again.',
  },

  // The "Make a picture" dialog (b2)
  dialogTitle: { id: 'app.sml.musicVideo.directed.picture.title', defaultMessage: 'Make a picture for the cast' },
  dialogText: {
    id: 'app.sml.musicVideo.directed.picture.textCast',
    defaultMessage:
      'Describe a person, a place or a thing. The AI makes a reference photo of it, and it shows in the cast in about 20 seconds.',
  },
  dialogRole: { id: 'app.sml.musicVideo.directed.picture.role', defaultMessage: 'Role' },
  dialogLabel: { id: 'app.sml.musicVideo.directed.picture.label', defaultMessage: 'Label' },
  dialogDescription: { id: 'app.sml.musicVideo.directed.picture.description', defaultMessage: 'Description' },
  dialogDescriptionPlaceholder: {
    id: 'app.sml.musicVideo.directed.picture.descriptionPlaceholder',
    defaultMessage: 'An old red 1970s estate car with rust on the doors, parked on a dirt road.',
  },
  dialogMake: { id: 'app.sml.musicVideo.directed.picture.make', defaultMessage: 'Make the picture' },
  dialogLeft: {
    id: 'app.sml.musicVideo.directed.picture.left',
    defaultMessage: '{left} of {total} AI pictures left for this video · free',
  },
  dialogClose: { id: 'app.sml.musicVideo.directed.picture.close', defaultMessage: 'Close' },
});
